export default __webpack_public_path__ + "static/media/globe-black.55982626.svg";